import { FullIeltsSamplePreviewUI } from '@doltech/modules/lib/ielts-sample/FullIeltsSamplePreviewUI';
import { DynamicPageProps } from '@doltech/routeDefinition';
import { LandingIeltsSampleDetailLayout } from '@doltech/modules/lib/ielts-sample/layouts/LandingIeltsSampleDetailLayout';
import * as React from 'react';
import { withUserActivityTracking } from '@doltech/modules/lib/landing/hocs/withUserActivityTracking';
import { ActivityTypeEnum } from '@doltech/utils/lib/constants';

interface WritingSampleDetailTemplatePageProps extends DynamicPageProps {}

const WritingSampleDetailTemplatePage = (props: WritingSampleDetailTemplatePageProps) => {
  const { seoData, pageData, internalPageLink } = props;
  const { detailData } = pageData;

  return (
    <FullIeltsSamplePreviewUI
      staticPageLink={internalPageLink.staticPageLink}
      seoData={seoData as any}
      detailData={detailData}
    />
  );
};

export default withUserActivityTracking({ type: ActivityTypeEnum.SAMPLE_WRITING })(
  WritingSampleDetailTemplatePage
);

export const WritingSampleDetailTemplatePageLayout = ({ children, ...pageProps }) => {
  return (
    <LandingIeltsSampleDetailLayout {...(pageProps as any)}>
      {children}
    </LandingIeltsSampleDetailLayout>
  );
};
